"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Input = void 0;

var react_1 = __importDefault(require("react"));

var prop_types_1 = __importDefault(require("prop-types"));

var component_library_waas_templates_base_input_template_1 = require("@tradesorg-components/component-library-waas-templates.base-input-template");

var component_library_waas_templates_base_input_phone_number_1 = require("@tradesorg-components/component-library-waas-templates.base-input-phone-number");

var component_library_waas_templates_base_input_dropdown_1 = require("@tradesorg-components/component-library-waas-templates.base-input-dropdown");

var component_library_waas_templates_base_input_textarea_1 = require("@tradesorg-components/component-library-waas-templates.base-input-textarea");

function Input(props) {
  var CInput = component_library_waas_templates_base_input_template_1.InputTemplate;

  switch (props.type) {
    case 'dropdown':
      CInput = component_library_waas_templates_base_input_dropdown_1.InputDropdown;
      break;

    case 'phone-number':
      CInput = component_library_waas_templates_base_input_phone_number_1.InputPhoneNumber;
      break;

    case 'textarea':
      CInput = component_library_waas_templates_base_input_textarea_1.BaseInputTextArea;
      break;

    default:
      CInput = component_library_waas_templates_base_input_template_1.InputTemplate;
      break;
  }

  return react_1.default.createElement(CInput, Object.assign({}, props));
}

exports.Input = Input;
Input.propTypes = {
  /**
   * A label input
   */
  label: prop_types_1.default.string,

  /**
   * A type input
   */
  type: prop_types_1.default.string,

  /**
   * A name input
   */
  name: prop_types_1.default.string,

  /**
   * A id input
   */
  id: prop_types_1.default.string,

  /**
   * A placeholder input
   */
  placeholder: prop_types_1.default.string,

  /**
   * A flag to check error input
   */
  errors: prop_types_1.default.object,

  /**
   * A flag to disable input
   */
  disabled: prop_types_1.default.bool,

  /**
   * A prefix for url
   */
  prefix: prop_types_1.default.string,

  /**
   * A list prefix domains for url
   */
  domainsPrefix: prop_types_1.default.arrayOf(prop_types_1.default.string),

  /**
   * Text helper
   */
  textHelper: prop_types_1.default.string,

  /**
   * Custom style by class name
   */
  classNames: prop_types_1.default.shape({
    wrapper: prop_types_1.default.string,
    label: prop_types_1.default.string,
    leftComponent: prop_types_1.default.string,
    input: prop_types_1.default.string,
    rightComponent: prop_types_1.default.string,
    helperText: prop_types_1.default.string
  }),

  /**
   * A flag for rounded input
   */
  rounded: prop_types_1.default.bool
};